// Import necessary modules
import { Button, Card, CardContent } from "@mui/material";
import { useNavigate } from "react-router-dom";

// Export the functional component
const RenderStories = ({ posts }) => {
  const navigate = useNavigate();

  if (!posts || posts.length === 0) {
    return (
      <div className="col-span-full text-center text-gray-500 text-lg">
        Not Found
      </div>
    );
  }

  const handleViewBlog = (postId, posts) => {
    const data = posts.find((item) => item._id === postId);
    console.log(data);
    navigate(`/blog/${postId}`, {
      replace: true,
      state: { data },
    });
  };

  return posts.map((post) => (
    <Button key={post._id} onClick={() => handleViewBlog(post._id, posts)}>
      <Card className="rounded-lg overflow-hidden shadow-md w-full h-full">
        <div className="relative h-48">
          <img
            src={post.image}
            alt={post.title}
            className="object-cover w-full h-full"
          />
        </div>
        <CardContent className="p-4">
          <h3 className="font-bold text-base sm:text-lg lg:text-xl mb-2 text-left line-clamp-2">
            {post.title}
          </h3>
        </CardContent>
      </Card>
    </Button>
  ));
};

export default RenderStories;
